import {http} from "@/plugins/axios"
import Licitacao from "@/model/licitacao"

//export default function() {

    function findAllTipos () {
        return http
            .get("/tiposlicitacao")
            .then((response) => response.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function findAllSituacoes () {
        return http
            .get("/situacaolicitacao")
            .then((response) => response.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function buscarLicitacao (id) {

        return http
            .get(`licitacao/${id}`)
            .then(res => Licitacao(res.data))
            .catch((e) => {
                console.log(e);
            });
    }

    function buscarLicitacaoFiltro (filtro) {

        return http
            .get("licitacao/filtro", {
                params: {
                    numero: filtro.numero,
                    ano: filtro.ano,
                    assunto: filtro.assunto,
                    tipoLicitacaoId: filtro.tipoLicitacaoId
                }
            })
            .then(res => res.data || [])
            .catch((err) => {
                // 404 = sem resultado (compatível com API antiga); outras falhas propagam
                if (err.response && err.response.status === 404) {
                    return [];
                }
                throw err;
              });
    }

    function downloadAnexo (id) {
        return http({
            url: `/licitacao/item/${id}/download`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            var header = (response.headers['content-disposition'])
            const indexOfInicio = header.indexOf("filename=");
            var filename = header.slice(indexOfInicio + 9);
            console.log(filename);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);

            fileLink.click();
        });
    }

    function salvar (licitacao, arquivos) {

        var formData = new FormData();
        formData.append("licitacao", JSON.stringify(licitacao));

        if (arquivos.length > 0) {
            for (var file of arquivos) {
                formData.append("arquivos", file)
            }
        }
        if (licitacao.licitacaoId == null) {
            //post
            return http
                .post("licitacao/", formData)
                .then((res) => Licitacao(res.data))
                .catch(err => console.error(err.message));

        } else { //put
            return http
                .put(`/licitacao/${licitacao.licitacaoId}`, formData)
                .then((res) => Licitacao(res.data))
                .catch(err => console.error(err.message));
        }
    }

    function excluirLicitacao(licId){
        return http
            .delete(`/licitacao/${licId}`)
            .then(res => {
                if(res.status === 204){
                    alert("Registro excluído com sucesso.")
                    return "ok"
                }
            })
            .catch((e) => {
                console.log(e);
                alert("Erro na solicitação.")
                return "erro"
            });
    }

    function excluirItemLicitacao(itemId){
        return http
            .delete(`/licitacao/item/${itemId}`)
            .then(res => {
                if(res.status === 200){
                    alert("Registro excluído com sucesso.")
                    return "ok"
                }
            })
            .catch((e) => {
                console.log(e);
                alert("Erro na solicitação.")
                return "erro"
            });
    }

    let service = {}
    service.findAllTipos = findAllTipos
    service.findAllSituacoes = findAllSituacoes
    service.buscarLicitacao = buscarLicitacao
    service.buscarLicitacaoFiltro = buscarLicitacaoFiltro
    service.downloadAnexo = downloadAnexo
    service.salvar = salvar
    service.excluirLicitacao = excluirLicitacao
    service.excluirItemLicitacao = excluirItemLicitacao

    export default service

//}

